import React from "react";
import {useLocation} from "react-use";

const Footer = props => {
    const location = useLocation();
    const openInNewTab = (url) => {
        const newWindow = window.open(url, "_blank");
        newWindow.focus();
    };
    return (<>

        <div className="footer">
          <span className='spanLink' onClick={() => {
            location.hostname.includes("aa") ? window.location = "tel:0800262411" : window.location = "tel:0800267873"
          }}>{location.hostname.includes("aa") ? "0800 262 411" : "0800 267 873"}</span> | <span className='spanLink'
                                                                                                   onClick={() => {
                                                                                                     window.location = "mailto:insurance@autosure.co.nz"
                                                                                                   }}>insurance@autosure.co.nz</span> |
          © Autosure | <span className='spanLink'
                             onClick={() => openInNewTab("https://autosure.co.nz/privacy-policy/")}>Privacy</span> | <span
          className='spanLink'
          onClick={() => openInNewTab("https://autosure.co.nz/terms-of-use/")}>Terms of Use</span>
        </div></>
    );
}

export default Footer;
